interface RequestButtonProps {
  onClick: () => void;
  disabled: boolean;
}

export const RequestButton = ({ onClick, disabled }: RequestButtonProps) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        background: disabled ? '#746f7e' : '#7750E9',
        maxWidth: 'var(--max-width)'
      }}
      className="w-[calc(100%-40px)] left-1/2 transform -translate-x-1/2 fixed bottom-20  h-[53px] py-4 bg-[#746f7e] rounded-lg justify-center items-center gap-2.5 inline-flex"
    >
      <div className="text-[#bcb8c3] text-base font-medium font-['Pretendard Variable'] leading-[21px]">
        요청하기
      </div>
    </button>
  );
};
